import { useState } from "react";
import { useTranslation } from "react-i18next";
import { usePaymnetContext } from "../..";
import { mnoCheckoutAPI, phoneVerificationAPI } from "../apiSercive";
import { getQueryStringValue, IPaymentPartner, PHONE_STATUS, PREVIEW_MODE } from "../common";
import { PaymentFooter } from "../payment.process/payment.process";

const PhoneConfirmation = ({ selectedPayment, onClose }: { selectedPayment?: IPaymentPartner; onClose: () => void }) => {
    const { state, update } = usePaymnetContext();
    const [loading, setLoading] = useState<boolean>(false);
    const { phone } = state;
    const { t } = useTranslation();

    const isValidate = (value: string) => {
        if (selectedPayment?.isMno) {
            //Rule for all MNO phone number validation 0XXXXXXXXX 
            return /^(0)\d{9}$/.test(value);
        }
        //Rule for all azampesa phone number validation 1XXXXXXXXX
        return /^(1)\d{9}$/.test(value);
    };

    const mnoCheckout = () => {
        if (state.mode === PREVIEW_MODE) {
            window.location.href = `/status?id=${PREVIEW_MODE}&provider=${selectedPayment?.provider}`
            return;
        }
        setLoading(true);
        let modal: any = {
            "provider": selectedPayment?.provider,
            "source": state.paymentDetail?.source || "Checkout Page",
            "amount": state.paymentDetail?.amount,
            "currency": selectedPayment?.currency,
            "accountNumber": phone.value,
            "externalId": state.paymentDetail?.externalId,
        }
        const paymentLinkId = getQueryStringValue("id")
        if (paymentLinkId) {
            modal = {
                ...modal,
                source: selectedPayment?.source || "Lipia Link",
                paymentLink: {
                    paymentLinkId: paymentLinkId,
                    vendorId: selectedPayment?.paymentVendorId
                }
            }
        }
        mnoCheckoutAPI(modal).then((data: any) => {
            if (data.success) {
                localStorage.setItem("pgvnext:paymentDetails", JSON.stringify({
                    amount: state.paymentDetail?.amount,
                    currency: selectedPayment?.currency,
                    vendorName: state.paymentDetail?.vendorName || state.paymentDetail?.appName,
                    redirectSuccessURL: state.paymentDetail?.redirectSuccessURL,
                    redirectFailURL: state.paymentDetail?.redirectFailURL,
                    topLeftLogo: state.layout.topLeftLogo,
                    topRightLogo: state.layout.topRightLogo
                }))
                window.location.href = `/status?id=${data.transactionId}&provider=${selectedPayment?.provider}`
            } else {
                setLoading(false);
                let message = data.message ? data.message : t("unsuccessPayment");
                if (data.messageCode && data.messageCode === 1000) {
                    message = t("1000")
                }

                update({
                    ...state,
                    success: true,
                    systemMessage: {
                        ...state.systemMessage,
                        show: true,
                        title: t("genralErrorTitle"),
                        message
                    }
                });
            }
        }).catch((error: any) => {
            setLoading(false);
            update({
                ...state,
                success: false,
                systemMessage: {
                    ...state.systemMessage,
                    show: true,
                    title: error?.code,
                    message: error.message
                }
            });
        })
    }

    const verifyPhoneNumber = (phone: string) => {
        if (state.mode === PREVIEW_MODE) {
            update({
                ...state,
                phoneStatus: PHONE_STATUS.PHONE_VERIFY
            })
            return;
        }
        setLoading(true);
        phoneVerificationAPI(phone, "1", selectedPayment?.source || "Lipia Link",).then((response: any) => {
            if (response.success) {

                if (response.data.status === "Failed") {
                    update({
                        ...state,
                        phone: { ...state.phone, error: response.data.COMMAND.MESSAGE },
                        phoneStatus: PHONE_STATUS.PHONE_NOT_REGISTER
                    })
                } else if (response.data.status === "Success") {
                    update({
                        ...state,
                        phoneStatus: PHONE_STATUS.PHONE_VERIFY
                    })
                }
            } else {
                update({
                    ...state,
                    success: true,
                    systemMessage: {
                        ...state.systemMessage,
                        show: true,
                        title: t("genralErrorTitle"),
                        message: response.message
                    }
                });
            }
            setLoading(false);
        }).catch((error: any) => {
            setLoading(false);
            update({
                ...state,
                success: false,
                systemMessage: {
                    ...state.systemMessage,
                    show: true,
                    title: error?.code,
                    message: error.message
                }
            });
        });
    }

    const phoneChange = (e: any) => {
        if (!e.target.value) {
            update({ ...state, phone: { value: "", error: t("requiredField") } })
        } else if (!isValidate(e.target.value)) {
            update({ ...state, phone: { value: e.target.value, error: t("vaidate") } })
        } else {
            update({ ...state, phone: { value: e.target.value, error: "" } })
        }
    }

    const submit = () => {
        if (loading) return;
        if (!state.phone.value) {
            return update({ ...state, phone: { value: "", error: t("requiredField") } })
        }
        if (state.phone.error) return;
        if (selectedPayment?.isMno) {
            return mnoCheckout();
        }
        verifyPhoneNumber(phone.value);
    }

    return (
        <>
            <p className="instruction">{selectedPayment?.isMno ? t("othersPhoneNumberMessage") : t("phoneNumberMessage", { vendor: "AzamPesa" })}</p>
            <div>
                <input
                    className={`input-txt ${phone.error ? "input-error" : ""}`}
                    type="text" value={phone.value}
                    disabled={loading}
                    placeholder={selectedPayment?.isMno ? t("phonePlaceholder") : t("azampayPhonePlaceholder")}
                    onChange={phoneChange} />
                <div className={phone.error ? "error" : ""}>{phone.error}</div>
            </div>
            <PaymentFooter loading={loading} submitTxt={t("phoneNumberProceed")} onClose={onClose} onSubmit={submit} />
        </>
    )
};

export default PhoneConfirmation;